import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "whitelist" }
const _hoisted_2 = { style: {"text-align":"right"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_4 = { class: "dialog-footer" }

import { defineComponent, ref, onMounted } from 'vue'
import {
  stationGetWhiteList,
  getUserList,
  stationDeleteWhiteList,
  stationAddWhiteList,
} from '@/api/operation'
import { ADO, ADOType } from '@/types/types'

import { ElMessageBox as MB } from 'element-plus'
import SelectRemoteAdoUser from '@/components/SelectRemoteAdoUser.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  stationID: {
    type: String,
    required: true, // 修复逗号问题
  },
  operatorID: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

const whitelistData = ref([])
const loading = ref(false)
// 对话框相关状态
const dialogVisible = ref(false)
const searchText = ref('')
const userOptions = ref([])
const selectedUser = ref(null)

const loadData = async () => {
  loading.value = true
  try {
    const res = await stationGetWhiteList({
      stationId: props.stationID,
      operatorId: props.operatorID,
    })
    whitelistData.value = res.list
  } catch (error) {
    console.error('Error fetching whitelist data:', error)
  } finally {
    loading.value = false
  }
}

const handleCreate = async () => {
  dialogVisible.value = true
  searchText.value = ''
  userOptions.value = []
  selectedUser.value = null
}

const searchUsers = async () => {
  if (searchText.value) {
    try {
      const res = await getUserList({
        pageReq: {
          page: 1,
          limit: 10,
          search: searchText.value,
        },
      })
      userOptions.value = res.list.map((user: any) => ({
        label: `${user.nickName}`,
        value: user,
      }))
    } catch (error) {
      console.error('Error fetching user info:', error)
    }
  }
}

const confirmUser = async () => {
  if (selectedUser.value) {
    // 处理选择的用户逻辑
    try {
      const res = await stationAddWhiteList({
        stationId: props.stationID,
        operatorId: props.operatorID,
        userIds: [selectedUser.value],
      })
    } catch (error) {
      console.log('Error add white list')
    }
    dialogVisible.value = false
    //刷新白名单列表
    await loadData()
  }
}

const handleDelete = async (row: any) => {
  // 处理删除白名单逻辑
  try {
    const res = await stationDeleteWhiteList({
      stationId: props.stationID,
      operatorId: props.operatorID,
      userIds: [row.userId],
    })
  } catch (error) {
    console.log('Error delete whitelist')
  }
  //刷新白名单列表
  await loadData()
}

onMounted(() => {
  loadData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleCreate
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.addWhiteList')), 1)
        ]),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: whitelistData.value }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: _ctx.$t('Base.username')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "phone",
          label: _ctx.$t('Operation.phone')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('Base.operation'),
          "class-name": "table-operation"
        }, {
          default: _withCtx((scope) => [
            (whitelistData.value.length > 0)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "text",
                  onClick: ($event: any) => (handleDelete(scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
      title: _ctx.$t('Base.searchUser')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmUser
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(SelectRemoteAdoUser, {
          modelValue: selectedUser.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedUser).value = $event)),
          operatorId: props.operatorID,
          ado: _unref(ADOType).ADOT_USER,
          minSearchKeyLen: 5
        }, null, 8, ["modelValue", "operatorId", "ado"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})